export default __webpack_public_path__ + "static/media/BGMusic.dfc57347.mp3";